<template>
  <div class="execution-view">
    <div class="left-view">
      <div class="header-view">设备列表</div>
      <div class="tree-list">
        <el-tree :data="deviceTree" node-key="id" :default-expanded-keys="expandedKeys" :props="defaultProps"
          @node-click="handleNodeClick">
          <template #default="{ node, data }">
            <span class="custom-tree-node">
              <span class="changespan" v-if="data.subDeviceNum">
                {{ data.label }}
                <div class="yuan" :class="{ 'yuan-ed': subdeviceArr.includes(data.id) }"></div>
              </span>
              <span v-else>{{ data.label }}</span>
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div class="right-view">
      <table class="table" border="1">
        <thead>
          <tr class="header-view">
            <th style="width: 36%">设备信息</th>
            <th>设备动作</th>
          </tr>
        </thead>
        <tbody class="tbody">
          <template v-if="tableList.length">
            <tr class="li" v-for="(item, index) in tableList" :key="index">
              <td style="line-height: 1.5;">{{ item.productNameName + "-" + item.deviceName + "-" + item.subDeviceName
                }}
              </td>
              <td class="operation">
                <!-- 开关设备 -->
                <template v-if="item.subDeviceType == '2-1'">
                  <div class="td-header">
                    <div class="ele" v-for="(ele, ind) in item.instructionList" :key="ind">
                      <div class="ele-top">
                        <div class="yuan" :class="{ 'yuan-ed': ele.check }"
                          @click="opanCloseClick(ele, item.instructionList)"></div>
                        <div class="label">{{ ele.commandsItemName }}</div>
                        <div class="txt" v-if="ele.commandsItemCode == '1'">
                          默认值:开启时长默认为 0
                          表示无限时长(无时间限制，持续开启)
                        </div>
                      </div>
                      <div class="input" v-if="ele.commandsItemCode == '1' && ele.check">
                        <el-input v-model="ele.attributeTime" placeholder="请输入开启时长" @input="timeInput">
                          <el-select slot="suffix" v-model="ele.attributeTimeType" placeholder="请选择" @change="selChange">
                            <el-option v-for="item in dateTypeList" :key="item.dictValue" :label="item.dictLabel"
                              :value="item.dictValue" >
                            </el-option>
                          </el-select>
                        </el-input>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 行程设备 -->
                <template v-if="item.subDeviceType == '2-2'">
                  <div class="td-header">
                    <div class="ele" v-for="(ele, ind) in item.instructionList" :key="ind">
                      <div class="ele-top">
                        <div class="yuan" :class="{ 'yuan-ed': ele.check }"
                          @click="opanCloseClick(ele, item.instructionList)"></div>
                        <div class="label">{{ ele.commandsItemName }}</div>
                      </div>
                      <div class="slider-view" v-if="ele.commandsItemCode == 'khd' && ele.check">
                        <el-slider v-model="ele.set" :step="1" :min="0" :max="100" :show-tooltip="false" show-input
                          :show-input-controls="false" :debounce="1000" input-size="large" @change="SilderChange(ele)"
                          @input="silderInput"></el-slider>
                      </div>
                    </div>
                  </div>
                </template>
              </td>
            </tr>
          </template>

        </tbody>
      </table>
      <template v-if="!tableList.length">
        <div class="tab-no-view">
          <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
          <div class="table-emptyword">请选择设备</div>
        </div>
      </template>
    </div>
    <Msg ref="tsmsg"></Msg>
  </div>
</template>

<script>
import Msg from "@/components/msg.vue"; //信息提示组件
export default {
  props: ["dateTypeList"],
  components: { Msg },
  data() {
    return {
      deviceTree: [
        // {
        // label: '全部',
        // children: [{
        //     label: '产品型号1',
        //     children: [{
        //         label: '控制箱1',
        //         children: [
        //             {
        //                 id: "1",
        //                 label: '电磁阀1',
        //                 type: "1",//代表是子设备
        //             },
        //             {
        //                 id: "2",
        //                 label: '电磁阀2',
        //                 type: "1",//代表是子设备
        //             }, {
        //                 id: "3",
        //                 label: '电磁阀3',
        //                 type: "1",//代表是子设备
        //             }
        //         ]
        //     },
        //     ]
        // },
        // {
        //     label: '产品型号2',
        //     children: [{
        //         label: '控制箱2'
        //     }]
        // }]
        // }
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      tempValue: 0,
      subdeviceArr: [],
      tableList: [
        // {
        //     "subDeviceNum": "1",
        //     "subDeviceName": "卷被机1",
        //     "subDeviceType": "2-2",
        //     "subDeviceIcon": "http://123.249.30.207:19000/icon/2022-11-17_10_49_41logo1.png",
        //     "sort": "1",
        //     "itemList": [
        //         {
        //             "dataItemCode": "e_stop",
        //             "dataItemName": "急停",
        //             "dataItemValue": "0"
        //         },
        //         {
        //             "dataItemCode": "khd",
        //             "dataItemName": "设备开度值",
        //             "dataItemValue": "30"
        //         },
        //         {
        //             "dataItemCode": "status",
        //             "dataItemName": "状态",
        //             "dataItemValue": "00"
        //         }
        //     ],
        //     "commandsItemList": [
        //         {
        //             "commandsItemCode": "00",
        //             "commandsItemName": "停止"
        //         },
        //         {
        //             "commandsItemCode": "10",
        //             "commandsItemName": "下降"
        //         },
        //         {
        //             "commandsItemCode": "01",
        //             "commandsItemName": "上升"
        //         }
        //     ],
        //     instructionList: [
        //         {
        //             "commandsItemCode": "1",
        //             "commandsItemName": "请选择需要运行的位置",
        //             check: true,
        //             actual: 0,
        //             set: 0,
        //         },
        //         {
        //             "commandsItemCode": "0",
        //             "commandsItemName": "关闭",
        //             check: false,
        //         }
        //     ]
        // },
        // {
        //     "subDeviceNum": "2",
        //     "subDeviceName": "冷暖风机",
        //     "subDeviceType": "2-1",
        //     "subDeviceIcon": "",
        //     "sort": "2",
        //     "itemList": [
        //         {
        //             "dataItemCode": "status",
        //             "dataItemName": "设备状态",
        //             "dataItemValue": "0"
        //         }
        //     ],
        //     "commandsItemList": [
        //         {
        //             "commandsItemCode": "1",
        //             "commandsItemName": "打开",
        //             check: false,
        //         },
        //         {
        //             "commandsItemCode": "0",
        //             "commandsItemName": "关闭",
        //             check: false,
        //         }
        //     ],
        //     instructionList: [
        //         {
        //             "commandsItemCode": "1",
        //             "commandsItemName": "打开",
        //             check: true,
        //             attributeTime: "",
        //             attributeTimeType: "1",
        //         },
        //         {
        //             "commandsItemCode": "0",
        //             "commandsItemName": "关闭",
        //             check: false,
        //         }
        //     ]
        // }
      ],
      attributeTimeTypeList: [
        {
          dictLabel: "秒",
          dictValue: "0",
        },
        {
          dictLabel: "分钟",
          dictValue: "1",
        },
        {
          dictLabel: "小时",
          dictValue: "2",
        },
      ],
      expandedKeys: []
    };
  },
  methods: {
    handleNodeClick(data) {
      console.log(data);
      if (data.subDeviceNum) {

        let value = data.id;
        let bool = this.subdeviceArr.indexOf(value) !== -1;
        if (!bool) {
          if (data.subDeviceType == "2-2") {
            this.$http
              .getAction(
                this.$api.queryDuration +
                "?deviceNum=" +
                data.deviceNum +
                "&subDeviceNum=" +
                data.subDeviceNum
              )
              .then((res) => {
                if (res.data) {
                  // 是否设置时长
                  if (data.productType == "1") {//控制箱设备
                    // 控制箱 总时长如果不为空,表示设置了, 总时长，单次时长，有一个为空，表示未设置
                    if (
                      res.data.onTotalDuration == undefined ||
                      res.data.onceOperationDuration == undefined ||
                      res.data.onceIntervalDuration == undefined
                    ) {
                      // 未设置时长
                      this.$refs.tsmsg.msgShow("该设备未设置初始化", 1.5);
                      return
                    } else {
                      // 已经设置时长
                      this.subdeviceArr.push(value);
                      let item = data;
                      item = this.subsetListHandle(item);
                      this.tableList.push(item);
                    }
                  } else {
                    // 非控制箱,如智能终端  正向总时长和反向总时长都设置了,才算设置,否则未设置
                    if (res.data.onTotalDuration && res.data.offTotalDuration) {
                      // 已经设置时长
                      this.subdeviceArr.push(value);
                      let item = data;
                      item = this.subsetListHandle(item);
                      this.tableList.push(item);
                    } else {
                      // 未设置时长
                      this.$refs.tsmsg.msgShow("该设备未设置初始化", 1.5);
                      return
                    }
                  }
                }
              })
          } else {
            this.subdeviceArr.push(value);
            let item = data;
            item = this.subsetListHandle(item);

            this.tableList.push(item);
          }




        } else {
          this.tableList.splice(this.subdeviceArr.indexOf(value), 1);
          this.subdeviceArr.splice(this.subdeviceArr.indexOf(value), 1);
        }
      }
    },
    // 获取行程设备当前开合度
    judgeKhd(item) {
      let num = 0;
      item.itemList.forEach((item, index) => {
        if (item.dataItemCode == "khd" && item.dataItemValue) {
          num = Number(item.dataItemValue);
        }
      });
      return num;
    },
    // 是否是汉字
    isAllChinese(str) {
      const reg = /^[\u4e00-\u9fa5]+$/;
      return reg.test(str);
    },
    // 处理子设备
    subsetListHandle(item) {
      // 智能终端
      if (item.productType != 1) {
        if (this.isAllChinese(item.subDeviceType)) {
          if (item.subDeviceType == "行程设备") {
            item.subDeviceType = "2-2";
          }
          if (item.subDeviceType == "开关设备") {
            item.subDeviceType = "2-1";
          }
        }
        // 开关设备
        if (item.subDeviceType == "2-1") {
          item.instructionList = item.commandsItemList;
          item.instructionList.forEach((ele) => {
            ele.check = false;
            if (ele.commandsItemCode == "1") {
              ele.attributeTime = "0";
              ele.attributeTimeType = "1";
            }
          });
          item.instructionList[0].check = true;
        }
        // 行程设备
        if (item.subDeviceType == "2-2") {
          item.instructionList = [];
          item.commandsItemList.forEach((ele) => {
            if (ele.commandsItemCode == "0") {
              ele.check = false;
              item.instructionList.push(ele);
            }
          });
          let obj = {
            commandsItemName: "选择需要运行的位置",
            order: "1",
            openingFit: "",
            actual: this.judgeKhd(item), // 设备初始位置
            set: this.judgeKhd(item), //设备设定位置
            check: false,
            commandsItemCode: "khd",
          };
          item.instructionList.unshift(obj);
          item.instructionList[0].check = true;
        }
      } else {
        // plc设备
        item.subDeviceType == "2-1";
        item.instructionList = item.commandsItemList;
        item.instructionList.forEach((ele) => {
          ele.check = false;
          ele.openTime = "";
          ele.attributeTime = "0";
          ele.attributeTimeType = "1";
        });
        item.instructionList[0].check = true;
      }
      return item;
    },
    // 回显子设备状态
    EchoSubItem(instructionItem, Paramsitem) {
      instructionItem = this.subsetListHandle(instructionItem);
      let item = instructionItem;
      // 开关设备
      if (item.subDeviceType == "2-1") {
        item.instructionList.forEach((ele) => {
          ele.check = false;
          if (ele.commandsItemCode == Paramsitem.propertyList[0].propertyValue.attributeType) {
            ele.check = true;
            if (ele.commandsItemCode == '1') {
              let attributeTime
              ele.attributeTimeType = Paramsitem.propertyList[0].propertyValue.attributeTimeType;
              if (ele.attributeTimeType == '0') {
                attributeTime = Number(Paramsitem.propertyList[0].propertyValue.attributeTime);
                ele.attributeTime = attributeTime
              } else if (ele.attributeTimeType == '1') {
                attributeTime = Number(Paramsitem.propertyList[0].propertyValue.attributeTime) / 60;
                ele.attributeTime = attributeTime
              } else if (ele.attributeTimeType == '2') {
                attributeTime = Number(Paramsitem.propertyList[0].propertyValue.attributeTime) / 60 / 60;
                ele.attributeTime = attributeTime
              }
            } else {

            }
          }
        })
      } else {
        // 行程设备
        item.instructionList.forEach((ele) => {
          ele.check = false;
          if (Paramsitem.propertyList[0].propertyValue.attributeKey == "khd") {
            if (ele.commandsItemCode == Paramsitem.propertyList[0].propertyValue.attributeKey) {
              ele.check = true;
              ele.set = Paramsitem.propertyList[0].propertyValue.attributeValue
            }
          } else {
            if (ele.commandsItemCode == Paramsitem.propertyList[0].propertyValue.attributeType) {
              ele.check = true;
            }
          }

        })
      }
      this.tableList.push(instructionItem);
      this.$forceUpdate()
    },
    timeInput(e) {
      this.$forceUpdate();
    },
    selChange(e) {
      console.log(e);
      
      this.$forceUpdate();
    },
    // 打开关闭点击
    opanCloseClick(ele, item) {
      item.forEach((a) => {
        a.check = false;
      });
      ele.check = true;
      this.$forceUpdate();
    },
    // 判断当前选择
    backthisChange(instructionList) {
      let arr = instructionList.filter((item) => {
        return item.check;
      });
      if (!arr.length) {
        return null;
      }
      return arr[0];
    },
    SilderChange(e) {
      console.log(e);
      console.log(this.tempValue);
      // if () {
      // }

      if (!Number.isInteger(e.set)) {
        e.set = Math.trunc(e.set);
      }
      if (Number.isNaN(e.set)) {
        e.set = 100;
        setTimeout(() => {
          e.set = 0;
        }, 20);
      }
      console.log(e.set);
      this.$forceUpdate();
    },
    silderInput(ele) {
      // this.$set(ele,"set",ele.set)
      //   this.$set(this.tableList[0].instructionList[0],"set",ele)
      this.$forceUpdate();
    },

    // 获取控制设备树形列表
    getdeviceTree(Paramsitem) {
      this.tableList = [];
      this.subdeviceArr = [];
      let params = {
        subType: "0",
        deviceName: this.deviceName,
      };
      this.$http
        .postAction(this.$api.userCloudExecutionList, params)
        .then((res) => {
          if (res.data) {
            res.data.forEach((item) => {
              item.label = item.productNameName;
              item.id = item.productNameCode;
              if (item.deviceList) {
                item.deviceList.forEach((ele) => {
                  ele.label = ele.deviceName;
                  ele.id = item.id + "$" + ele.deviceNum;
                  if (ele.subsetList) {
                    ele.subsetList.forEach((a) => {
                      a.productNameName = item.productNameName
                      a.label = a.subDeviceName;
                      a.id = ele.id + "$" + a.subDeviceNum;
                      a.deviceName = ele.deviceName;
                      a.deviceNum = ele.deviceNum;
                      a.productType = ele.productType;
                      a.deviceId = ele.deviceId;
                      a.deviceCompId = ele.deviceCompId;
                      if (Paramsitem) {
                        Paramsitem.forEach((b) => {
                          let deviceNum_ = b.propertyList[0].deviceNum
                          let subDeviceNum_ = b.propertyList[0].deviceSubNum
                          if (deviceNum_ == a.deviceNum && subDeviceNum_ == a.subDeviceNum) {
                            this.subdeviceArr.push(a.id);
                            this.EchoSubItem(a, b)
                          }
                        })
                        this.expandedKeys = this.subdeviceArr
                        this.$forceUpdate();
                      }
                    });
                    ele.children = ele.subsetList;
                  }
                });
                item.children = item.deviceList;
              }
            });
            this.deviceTree = res.data;
            this.$forceUpdate();
          } else {
            this.deviceTree = [];
          }
        });
    },
    // 提交验证
    submitYZ() {
      // this.submitClick();
      // return
      let res = {
        code: null,
        msg: null
      }
      if (!this.tableList.length) {
        res.code = 500;
        res.msg = "请选择设备"
        return res;
      }
      try {

        this.tableList.forEach((item) => {
          // 智能终端
          if (item.subDeviceType == "2-1") {
            item.instructionList.forEach((ele) => {
              if (ele.commandsItemCode == "1" && ele.attributeTime === "") {
                throw new Error("请输入开启时长");
              }
            })
          }
        })
        res.code = 200;
        this.submitClick();

      } catch (error) {
        res.code = 500;
        res.msg = error
      }
      return res
    },
    submitClick() {
      let arr = []
      this.tableList.forEach((item) => {
        let instructionList = item.instructionList.filter((ele) => {
          return ele.check
        })
        item.instructionList = instructionList
      })
      this.tableList.forEach((item) => {
        let value = {
          propertyName: '',
          propertyType: 'cloud_scene_execute',
          operateType: '4',
          productType: '',
          propertyList: []
        }
        value.propertyName = item.subDeviceName;
        let operationName = '';
        // 开关设备
        if (item.subDeviceType == "2-1") {
          item.instructionList.forEach((ele) => {
            if (ele.commandsItemCode == '1') {
              let attributeTime = '';
              let attributeTimeText = "";
              if (ele.attributeTime == 0) {
                attributeTime = 0;
              } else {
                if (ele.attributeTimeType == '0') {
                  attributeTime = Number(ele.attributeTime);
                  attributeTimeText = ele.attributeTime + "秒"
                } else if (ele.attributeTimeType == '1') {
                  attributeTime = Number(ele.attributeTime) * 60;
                  attributeTimeText = ele.attributeTime + "分钟"
                } else if (ele.attributeTimeType == '2') {
                  attributeTime = Number(ele.attributeTime) * 60 * 60;
                  attributeTimeText = ele.attributeTime + "小时"
                }
              }
              let obj = {
                propertyKey: '4',
                propertyValue: {
                  attributeKey: 'status',
                  attributeValue: '',
                  attributeType: ele.commandsItemCode,
                  attributeTime: attributeTime + '',
                  attributeTimeType: ele.attributeTimeType,
                  attributeName: ele.commandsItemName + attributeTimeText
                },
                deviceNum: item.deviceNum,
                deviceId: item.deviceId,
                deviceSubNum: item.subDeviceNum,
                deviceCompNum: item.deviceCompId,
                sort: value.propertyList.length + 1
              };
              value.propertyList.push(obj)
            } else {
              let obj = {
                propertyKey: '3',
                propertyValue: {
                  attributeKey: 'status',
                  attributeValue: '',
                  attributeType: ele.commandsItemCode,
                  attributeName: ele.commandsItemName
                },
                deviceNum: item.deviceNum,
                deviceId: item.deviceId,
                deviceSubNum: item.subDeviceNum,
                deviceCompNum: item.deviceCompId,
                sort: value.propertyList.length + 1
              };
              value.propertyList.push(obj)
            }
          })
          operationName = value.propertyList[0].propertyValue.attributeName;
        } else {
          // 行程设备
          item.instructionList.forEach((ele) => {
            if (ele.commandsItemCode == 'khd') {
              let obj = {
                propertyKey: '3',
                propertyValue: {
                  attributeKey: 'khd',
                  attributeValue: ele.set,
                  attributeType: '1',
                  attributeName: '执行到' + ele.set + '%'
                },
                deviceNum: item.deviceNum,
                deviceId: item.deviceId,
                deviceSubNum: item.subDeviceNum,
                deviceCompNum: item.deviceCompId,
                sort: value.propertyList.length + 1
              };
              let attributeType = "";
              if (ele.set < ele.actual) {
                attributeType = "2"
              } else {
                attributeType = "1"
              }
              obj.propertyValue.attributeType = attributeType;
              value.propertyList.push(obj)
              operationName = '执行到' + ele.set + '%';
            } else {
              let obj = {
                propertyKey: '3',
                propertyValue: {
                  attributeKey: 'status',
                  attributeValue: '',
                  attributeType: ele.commandsItemCode,
                  attributeName: ele.commandsItemName
                },
                deviceNum: item.deviceNum,
                deviceId: item.deviceId,
                deviceSubNum: item.subDeviceNum,
                deviceCompNum: item.deviceCompId,
                sort: value.propertyList.length + 1
              };
              value.propertyList.push(obj)
              operationName = ele.commandsItemName;
            }
          })

        }
        value.propertyName = value.propertyName + operationName;
        arr.push(value)
      })
      this.$emit("executeEmitFun", arr)
    }
  },
};
</script>

<style lang="scss" scoped>
.execution-view {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0.175rem;
  display: flex;
  overflow: auto;

  .left-view {
    display: flex;
    flex-direction: column;
    margin-right: 0.1625rem;
    width: 3.45rem;
    height: 100%;
    border-radius: 0.125rem;
    border: 1px solid #e5e5e5;
    overflow: auto;

    .header-view {
      height: 0.675rem;
      box-sizing: border-box;
      border-bottom: 1px solid #f1f1f1;
      box-sizing: border-box;
      padding-left: 0.1375rem;
      display: flex;
      align-items: center;

      &::before {
        margin-right: 0.125rem;
        content: "";
        width: 3px;
        height: 15px;
        background: #2daea9;
      }
    }

    .tree-list {
      flex: 1;
      overflow: auto;

      .custom-tree-node {
        flex: 1;
        text-align: left;

        .changespan {
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;
          padding-right: 0.225rem;
        }

        .yuan {
          position: relative;
          box-sizing: border-box;
          border: 1px solid #dbdbdb;
          width: 0.175rem;
          height: 0.175rem;
          background: #ffffff;
          border-radius: 0.05rem;
          border: 1px solid #dbdbdb;
        }

        .yuan-ed {
          border-color: #2daea9;

          &::after {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            content: "";
            width: 0.125rem;
            height: 0.125rem;
            background: url("~@/assets/image/cloudscene/mti.png") no-repeat;
            background-size: 100% 100%;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .right-view {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: auto;

    .table {
      width: 100%;
      // height: 100%;
      border-color: #f1f1f1;
    }

    .header-view {
      height: 54px;
      background: #f3f7f8;
    }

    .li {
      td {
        padding: 0.3rem 0.2rem;
      }

      .td-header {
        display: flex;
        justify-content: space-between;
        padding-right: 20px;

        .ele {
          .ele-top {
            display: flex;
            align-items: center;
          }

          .label {
            margin-right: 0.1rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 0.175rem;
            color: #454545;
            margin-left: 0.075rem;
          }

          .txt {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 0.175rem;
            color: #cccccc;
          }

          ::v-deep .input {
            margin-top: 0.175rem;

            .el-input__suffix {
              right: 0;

              .el-select {
                width: 67px;

                .el-input__inner {
                  padding-right: 10px;
                  padding-left: 10px;
                  background: #f3f7f8;
                }
              }
            }
          }

          ::v-deep .slider-view {
            width: 350px;
            margin-top: 14px;
            display: flex;
            align-items: center;
            padding-left: 8px;

            .el-slider {
              width: 350px !important;

              .el-input {
                position: relative;

                &::before {
                  position: absolute;
                  right: 5px;
                  line-height: 40px;
                  content: "%";
                }
              }

              .el-slider__bar {
                background-color: #2daea9;
              }

              .el-slider__button {
                border-color: #2daea9;
              }
            }

            .el-input {
              margin-left: 0.15rem;
              width: 0.875rem;
            }
          }
        }

        .yuan {
          cursor: pointer;
          position: relative;
          width: 0.2rem;
          height: 0.2rem;
          box-sizing: border-box;
          background: #ffffff;
          border-radius: 50%;
          border: 1px solid #dbdbdb;
        }

        .yuan-ed {
          border-color: #2daea9;

          &::after {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            content: "";
            width: 0.1rem;
            height: 0.1rem;
            background: #2daea9;
            border-radius: 50%;
          }
        }
      }

      .input {
        width: 310px;
      }
    }

    .tbody {
      position: relative;
      overflow: auto;


    }

    .tbody-no {
      width: 100%;
      height: calc(100% - 54px);
    }

    .tab-no-view {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .table-emptyword {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>